import { useRef } from "react";
/**
 * Generates a unique (stable) ID for a component. Should be replaced with React.useId once we support only React 18.
 */ export function useId(prefix) {
    if (globalThis.useIdValue === undefined) {
        globalThis.useIdValue = 0;
    }
    const id = useRef(undefined);
    if (id.current === undefined) {
        id.current = `${prefix}-${globalThis.useIdValue++}`;
    }
    return id.current;
}

//# sourceMappingURL=component-ids.js.map